module.exports = __webpack_public_path__ + "img/law1m-m@2.3d1935c0.webp";